export default __webpack_public_path__ + "static/media/img-0087-japan-half-face.48c99ea0.png";